import React, {useContext, useEffect, useState} from "react";
import {Link, useLocation} from "react-router-dom";
import moment from "moment/moment";
import LoaderCircle from "../../../loader/LoaderCircle";
import ConsultationIcon from "../../../icons/ConsultationIcon";
import StoreController from "../../../../stories/_client/Stores/StoreController";
import AppContext from "../../../../context/AppContext";

const LastViewed = () => {
	const { setEvent, setBubbleText } = useContext(AppContext);
	const [ list, setList ] = useState([]);
	const [ loading, setLoading ] = useState(true);
	const location = useLocation();

	const refresh = () => {
		const controller = new StoreController();
		controller._callback = handleRefresh;
		controller.getLastViewed(6);
	}
	const handleRefresh = (list, error, status) => {
		setLoading(false);

		switch (status) {
			case 200:
				setList(list);
				break;
			default:
				setEvent({
					type: "error",
					text: "Une erreur s'est produite lors du chargement des dernières consultations"
				});
				break;
		}
	}

	useEffect(() => {
		refresh();
	}, []);
	useEffect(() => {
		if (location !== undefined && location.state !== undefined && location.state === "closeFrontSheet")
			refresh();
	}, [location]);

    return (
        <div className="block lastViewed">
			<div className={"containerTitle"}>
				<ConsultationIcon />
				<p>Dernières consultations</p>
			</div>
			<div className={"list"}>
				{
					loading
						? <LoaderCircle display="loader loadingDashboard" strokeWidth="8" stroke="#006D3E" />
						: (
							list.length > 0
								? list.map((history, index) => (
									<Link key={index} to={ "clients/" + history.store_id + "/informations" } onClick={() => { setBubbleText(null) }}>
										<div key={index} className={"elmt"}
											 onMouseOver={() => { setBubbleText(history.comment) }}
											 onMouseOut={() => { setBubbleText(null) }}>
											<p className={"text"}>{ history.store_name }</p>
											<p className={"since"}>Il y a { moment(history.created_at).fromNow(true) }</p>
										</div>
									</Link>
								))
								: <div className={"elmt empty"}><p className={"text empty"}>Aucune consultation</p></div>
						)
				}
			</div>
		</div>
    )
}

export default LastViewed;
